import { Text } from '@thanx/uikit/text'
import { useStyletron } from '@thanx/uikit/theme'
import { buildTranslate } from 'locales'
import React from 'react'
import DescriptionLink from 'scenes/Cms/components/DescriptionLink'
import { getImageUrl } from 'scenes/Cms/Content/AppHomePage/Content/helper'
import { FeaturedContentSlideData } from 'slices/appLandingPageTheme/types'

type Props = {
  slide: FeaturedContentSlideData
  index: number
}

const t = buildTranslate(
  'cms.content.app_home_page.content.block_item.featured_content_carousel'
)

const SlideDescription = ({ slide, index }: Props) => {
  const [css] = useStyletron()

  if (slide.type !== 'featured_content') return null

  const { image, url } = slide
  const imageSrc = getImageUrl(image)

  return (
    <div
      className={css({
        border: '1px solid #e0e0e0',
        borderRadius: '8px',
        padding: '12px',
        marginBottom: '8px',
        backgroundColor: 'white',
      })}
    >
      {/* Title */}
      <Text.BodyText3 tag="h4" color="grey90" bold className="mb-s">
        {t('slide', { index: index })}
      </Text.BodyText3>

      {/* Image */}
      {imageSrc ? (
        <img
          src={imageSrc}
          className={`mb-s ${css({ height: '115px' })}`}
          alt={t('image_alt')}
        />
      ) : (
        <div
          className={css({
            height: '80px',
            width: '100%',
            backgroundColor: '#f5f5f5',
            borderRadius: '4px',
            marginBottom: '8px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            border: '1px dashed #ccc',
          })}
        >
          <Text.BodyText4 tag="span" color="grey70">
            No image
          </Text.BodyText4>
        </div>
      )}

      <DescriptionLink url={url} />
    </div>
  )
}

export { SlideDescription }
